import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ErrorCircleSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 20 20",
  color = "#AA2121",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <g clipPath="url(#errorCircle_svg__clip0)">
        <path
          d="M17.071 2.929A9.935 9.935 0 0010 0a9.935 9.935 0 00-7.071 2.929A9.935 9.935 0 000 10a9.935 9.935 0 002.929 7.071A9.935 9.935 0 0010 20a9.935 9.935 0 007.071-2.929A9.935 9.935 0 0020 10a9.935 9.935 0 00-2.929-7.071zm-2.746 10.015a.977.977 0 01-1.381 1.381L10 11.381l-2.944 2.944a.974.974 0 01-1.381 0 .977.977 0 010-1.38L8.619 10 5.675 7.056a.977.977 0 011.38-1.381L10 8.619l2.944-2.944a.977.977 0 111.381 1.381L11.381 10l2.944 2.944z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="errorCircle_svg__clip0">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { ErrorCircleSvg };
